import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";
import { ISkillGroup } from "@skills-app/models/skillGroup";

@Component({
  standalone: false,
  selector: "app-manage-skill-group-list",
  templateUrl: "./skill-group-list.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./skill-group-list.component.css"],
})
export class SkillGroupListComponent {
  @Input() skillGroups: ISkillGroup[] = [];
  @Input() uncategorizedSkillGroups: ISkillGroup[] = [];
  @Input() thingspaceDraggableList = false;

  @Output() skillGroupSelected = new EventEmitter<ISkillGroup>();

  selectedSkillGroup?: ISkillGroup;

  selectSkillGroup(skillGroup: ISkillGroup): void {
    this.selectedSkillGroup = skillGroup;
    this.skillGroupSelected.emit(skillGroup);
  }
}
